// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3p7nZ","requiredAsterisk":"Info_requiredAsterisk__RQj1U"};